<template>
  <div class="diadin">

    <div class="title">
      <el-form :inline="true" :model="formInline" class="demo-form-inline">
        <el-form-item>
          <el-input class="cinput" :placeholder="$t('menu.Bykeywords')" clearable v-model="formInline.title"></el-input>
          <el-button type="primary" @click="search">{{ $t('menu.search') }}</el-button>
        </el-form-item>
      </el-form>
      <div class="bonntbot">
        <el-tabs v-model="action" @tab-click="searchType">
          <el-tab-pane v-for="(item, index) in titleList" :key="index"
            :label="item.num !== 0 ? item.dictLabel + '(' + item.num + ')' : item.dictLabel"
            :name="item.dictValue"></el-tab-pane>

        </el-tabs>

        <div class="bonntbota">
          <el-checkbox v-model="checked" @change="changeType">{{ $t('menu.Onlyunread') }}</el-checkbox>
        </div>

      </div>


    </div>




    <!-- <el-table :data="mation" style="width: 100%" stripe border highlight-current-row @row-click="getDetails">
      <el-table-column prop="noticeTitle" label="标题">
        <template slot-scope="scope">
          <div class="row-title">
            {{ scope.row.noticeTitle }}
          </div>
        </template>
</el-table-column>
<el-table-column prop="createTime" label="类型" width="280"> </el-table-column>
<el-table-column prop="createTime" label="状态" width="280"> </el-table-column>
<el-table-column prop="createTime" label="发布时间" width="280"> </el-table-column>
</el-table> -->


    <el-collapse v-model="activeNames" @change="handleChange" v-if="mation.length > 0">
      <template v-for="item in mation">
        <el-collapse-item :name="item.id">
          <template slot="title">
            <div style="display: flex; justify-content: space-between;width: 100%;padding-right: 10px;"
              :class="item.status == '9' ? 'cctitle' : ''" @click="updateNotice(item.id, item.status)">
              <div>
                {{ item.noticeTitle }}
              </div>
              <div>
                {{ item.createTime }}
               
              </div>
            </div>
           
          </template>
          <div class="content-box">
            <!-- <el-button class="qianshou" @click="updateNotice(item.id)">签收</el-button> -->
            <div v-html="item.noticeContent"></div>
            <div style="display: flex;margin-top: 20px;">
              <div class="cbjqq" @click="djxz(item.file1Path)">{{ item.file1Path |cbjq}}</div>
              <div class="cbjqq" @click="djxz(item.file2Path)">{{ item.file2Path |cbjq}}</div>
              <div class="cbjqq" @click="djxz(item.file3Path)">{{ item.file3Path |cbjq}}</div>
              <div class="cbjqq" @click="djxz(item.file4Path)">{{ item.file4Path |cbjq}}</div>
              <div class="cbjqq" @click="djxz(item.file5Path)">{{ item.file5Path |cbjq}}</div>
            </div>
          </div>
        </el-collapse-item>
      </template>

    </el-collapse>

    <div class="bottompage">
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage3"
        :page-sizes="[50, 100]" :page-size="pagesize" layout="total,sizes, prev, pager, next" :total="totale">
      </el-pagination>

    </div>


    <el-dialog :visible.sync="dialogVisible" :close-on-click-modal="false" :close-on-press-escape="false"
      :show-close="false" width="50%">
      <div class="pop">
        <div class="title">
          <p>{{ detailsInfo.noticeTitle }}</p>
          <p class="btn1" @click="updateNotice(detailsInfo.id)" style="cursor: pointer;">{{ $t('menu.Receive') }}</p>
        </div>
        <div class="content" v-html="detailsInfo.noticeContent"></div>
        <div>{{ detailsInfo.createTime }}</div>
      </div>
    </el-dialog>

  </div>
</template>

<script>
import { noticetDetails, noticetList, setNoticet, querytype } from "../../api/api";
import Utils  from "../../utils/uilt.js";
export default {
  data () {
    return {
      detailsInfo: {},
      dialogVisible: false,
      currentPage3: 1,
      pagesize: 50,
      totale: 3,
      activeNames: '',
      action: '',
      inle: 'zh',
      titleList: [
        {
          dictValue: '',
          dictLabel: this.$t('menu.All'),
          num: 0
        },
        // {
        //   dictValue: '',
        //   dictLabel: '零件变更（23）'
        // },
        // {
        //   dictValue: '',
        //   dictLabel: '服务公告（23）'
        // },
        // {
        //   dictValue: '',
        //   dictLabel: '培训材料'
        // },
        // {
        //   dictValue: '',
        //   dictLabel: '系统升级'
        // },
        // {
        //   dictValue: '',
        //   dictLabel: '活动通知'
        // },
      ],
      activeName: "first",
      mation: [], //列表
      formInline: {
        title: "",
        status: "",
        startTime: "",
        endTime: "",
        contact: "",
        category: "",
        type: "",
      },
      a: false,
      b: false,
      checked: false,
      num: [],
    };
  },
  created () {
    this.biao();
    let a = sessionStorage.getItem('i18n')
    this.inle = a

  },
  filters: {
    cbjq: function (e) {
      let a =''
      let b =''
      console.log(e);
      if(e!==null){
        a = e.split('/')
    
        b=a[a.length-1]
        
      }
      return b
  }
},
  
  methods: {
    djxz(e){
      window.location.href = e;
    },
    changeType () {
      if (this.checked) {
        this.formInline.status = 0
      } else {
        this.formInline.status = ''
      }
      console.log(this.formInline)
      this.biao1();
    },
    searchType (tab, event) {
      this.action = tab.name
      this.biao1()
      // console.log(tab);

      // this.formInline.category = this.titleList[tab.index].dictValue
      // this.biao()
    },
    handleChange (val) {
      // console.log(val);

    },
    updateNotice (id, i) {
      // console.log(i);

      if (i !== '9') {
        setNoticet({ id: id }).then(r => {
          if (r.data.code == 200) {
            console.log(r)
            let a =   sessionStorage.getItem('noticeTotal')
            sessionStorage.setItem('noticeTotal', a-1)
            Utils.$emit('demo','msg');
          }

          this.biao1()
          console.log(r)
          this.mation[i].status = 9
          // this.$message.success(r.data.msg)
          // this.dialogVisible = false
        })
      } else {
        // console.log(1);

      }

    },
    getDetails (row, column, event) {
      let param = new URLSearchParams();
      noticetDetails(
        param,
        row.id
      ).then(r => {
        if (r.data.code == 200) {
          this.detailsInfo = r.data.data
          this.dialogVisible = true
        }
      })
    },
    querytypea () {
      let param = new URLSearchParams();
      querytype(
        param,
        'sys_notice_type'
      ).then(r => {
        if (r.data.code == 200) {
          let a = this.titleList
          r.data.data.forEach(e => {
            let B = {
              dictLabel:this.sxtitle(e) ,
              dictValue: e.dictValue,
              num: 0
            }
          

            a.push(B)
          });
          this.num.forEach(e => {
            a.forEach((z, i) => {
              if (e.noticeType == z.dictValue) {
                a[i].num = e.sum
              }
            })

          })
          console.log(a);
          this.titleList = a


        }
      })
    },
       sxtitle(e){
      let a =''
       
      if(this.inle=='zh'){
        a=e.dictLabel
      }
    if(this.inle=='en'){
      if(e.dictLabelEn.indexOf(":") !== -1){
       
        let c =JSON.parse(e.dictLabelEn)
     
        a=c.en
      }else{
        a=e.dictLabelEn
      }
      

      }
      if(this.inle=='de'){
         if(e.dictLabelEn.indexOf(":") !== -1){
             let d =JSON.parse(e.dictLabelEn)
a=d.de
         } else{
        a=e.dictLabelEn
      } 
         
      
      }
      return a

    },
    search () {
      this.biao1()
    },
    async biao () {
      let param = new URLSearchParams();
      let category = this.formInline.category;
      let type = this.formInline.type;
      let startTime = this.formInline.startTime;
      let endTime = this.formInline.endTime;
      let status = this.formInline.status;
      let searchValue = this.formInline.title;
      const { data: res } = await noticetList(
        param,
        status,
        searchValue,
        this.action,
        this.currentPage3,
              this.pagesize,
        'desc',
        'id',
      );

      this.mation = res.rows;
      this.num = res.summary
      this.totale = res.total;
      this.querytypea()
    },
    async biao1 () {
      let param = new URLSearchParams();
      let category = this.formInline.category;
      let type = this.formInline.type;
      let startTime = this.formInline.startTime;
      let endTime = this.formInline.endTime;
      let status = this.formInline.status;
      let searchValue = this.formInline.title;
      if (this.action == 0) {
        this.action = ''
      }
      const { data: res } = await noticetList(
        param,
        status,
        searchValue,
        this.action,
        this.currentPage3,
        this.pagesize,
        'desc',
        'id'
      );

      this.mation = res.rows;
      this.num = res.summary
      this.totale = res.total;

    },
    handleSizeChange (val) {
      this.pagesize=val
      this.biao1();
      console.log(`每页 ${val} 条`);

    },
    handleCurrentChange (val) {
      this.currentPage3=val
      this.biao1();
    },
    downLoad (row) {
      const a = document.createElement('a')

      a.href = this.common.httpUrl + row.filePath
      // a.href = 'http://fdms-test.bendamotor.cn/bendaFDMSTestWeb' + row.filePath
      a.download = row.fileName // 下载后文件名
      a.style.display = 'none'
      document.body.appendChild(a)
      a.click() // 点击下载
      document.body.removeChild(a) // 下载完成移除元素
    }
  },
};
</script>

<style lang="less" scoped>
.avatar {
  width: 178px;
  height: 178px;
  display: block;
}

.cinput {
  width: 300px;
  margin-right: 10px;
}

.diadin {
  width: 100%;
  min-height: 80vh;
  background-color: #fff;
  padding: 20px;
  padding-left: 0;
}

.bonntbot {
  padding-bottom: 10px;
  position: relative;


}

.bonntbota {
  position: absolute;
  right: 10px;
  top: 0;
}

.bottompage {
  display: flex;
  justify-content: flex-end;
  padding-top: 20px;
}

.pop {
  .title {
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid #eee;
    padding-bottom: 20px;

    .btn1 {
      width: 100px;
      height: 40px;
      display: flex;
      align-items: center;
      justify-content: center;
      color: #fff;
      background-color: #409eff;
    }
  }

  .content {
    margin-bottom: 20px;
  }
}

/deep/.el-table {
  min-height: 750px !important;
}

/deep/.el-table__body td {
  padding: 20px !important;
  padding-left: 0 !important;
  text-align: left;
}

/deep/.el-table th.is-leaf {
  text-align: left;
}

/deep/.el-tabs {
  height: 97%;
  width: 100%;
}
.cbjqq{
  margin-right: 10px;
  cursor: pointer;
  color: #409eff;
}
/deep/.el-tabs__content {
  width: 100%;
  height: 100%;
}

.cctitle {
  color: #999999;
}

/deep/.el-table--scrollable-x .el-table__body-wrapper {
  height: 90%;
}

/deep/.el-tab-pane {
  height: 82%;
}

/deep/.el-table--fit {
  height: 94%;
}

.xz-box {
  width: 400px;
  margin: 0 auto;
}

.btn {
  display: flex;
  justify-content: space-evenly;
  color: #31aff2;

  p {
    cursor: pointer;
  }
}

.title {
  padding-bottom: 10px;


  .status {
    display: flex;
    margin-top: 20px;

    div {
      margin-right: 25px;
      cursor: pointer;
    }
  }
}

.row-title {
  font-size: 18px;
  color: #222222;
  font-weight: 550;
}

.content-box {
  position: relative;
  background-color: #f2f2f2;
  border-radius: 10px;
  padding: 8px 4px;

  .qianshou {
    position: absolute;
    right: 0;
    top: 0;
  }
}
</style>